/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/sections/publish.jsx

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { Typography, FormHelperText, Box, TextField } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import AsyncSelect from 'react-select/async';
import {
  Field,
  Form,
  reduxForm,
  getFormValues,
  getFormSyncErrors,
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BASE_API, USER_TOKEN } from 'config/consts';
import { toastr } from 'react-redux-toastr';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { InputSwitchLarge } from 'common/components/fields/InputSwitchLarge';
import { SelectMultiple } from 'common/components/fields/SelectMultiple';
import { SelectLabel } from 'common/components/fields/SelectLabel';

import states from 'helpers/states.json';
import { FORM_RULES } from 'helpers/validations';
import _ from 'lodash';

import { requiredFieldError } from 'modules/owner/pages/actions/actionsFile';
import {
  getContactsByStationIdLimited,
  getUsersByIds,
} from 'modules/owner/pages/contacts/contactsActions';
import { getList as getPlansList } from '../../../plans/plansActions';
import { change } from 'redux-form';
import {
  AudienceSection,
  initAudienceFields,
  buildAudienceTypes,
  isStationGuestFeatureEnabled,
  hasAnyAudienceSelected,
} from '../../sections/audienceSection';

class Publish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states: [],
      submitted: false,
      poppedUp: false,
      callback: null,
      options: [],
      selectedValues: [],
      isAsyncInputDirty: false,
    };

    const seg = Array.isArray(props.formValues.segment_users)
      ? props.formValues.segment_users
      : [];
    if (seg.length) props.getUsersByIds(seg);

    // carrega lista de planos
    props.getPlansList(
      props.auth.user.establishments[0].stations[0].id
    );
  }

  componentDidMount() {
    const ordered = [
      { id: 10, sigla: 'all', nome: 'Todos' },
      ...states,
    ].sort((a, b) => {
      if (a.id === 10) return -1;
      if (b.id === 10) return 1;
      return a.sigla.localeCompare(b.sigla);
    });
    this.setState({ states: ordered });

    initAudienceFields({
      auth: this.props.auth,
      formValues: this.props.formValues,
      changeField: this.props.changeField,
      form: 'tanqueCheioForm',
    });
  }

  componentDidUpdate(prevProps) {
    const { submitErrors, contacts } = this.props;

    // exibe popup de erro de validação
    if (
      !_.isEmpty(submitErrors) &&
      this.state.submitted &&
      !this.state.poppedUp
    ) {
      this.props.requiredFieldError();
      this.setState({ poppedUp: true, submitted: false });
    }
    if (submitErrors !== prevProps.submitErrors && this.state.poppedUp) {
      this.setState({ poppedUp: false });
    }

    // quando a lista de contatos chega
    if (
      !contacts.loading &&
      contacts.list.content?.length > 0 &&
      prevProps.contacts.list.content !== contacts.list.content
    ) {
      const opts = contacts.list.content.map(u => ({
        value: u.id,
        label: u.email,
      }));
      this.setState({ options: opts });
      if (this.state.callback) this.state.callback(opts);
    }

    // quando os valores padrão de contatos chegam
    if (
      !contacts.loading &&
      contacts.list.defaultValues?.length > 0 &&
      prevProps.contacts.list.defaultValues !==
        contacts.list.defaultValues
    ) {
      const sel = contacts.list.defaultValues.map(u => ({
        value: u.id,
        label: u.email,
      }));
      this.setState({ selectedValues: sel });
    }
  }

  getSelectContacts = (inputValue, callback) => {
    this.setState({ callback });
    this.props.getContactsByStationIdLimited(
      this.props.auth.user.establishments[0].stations[0].id,
      inputValue
    );
  };

  lazySelect = field => {
    const { formValues } = this.props;
    const now = new Date();
    const disabled =
      !formValues.is_draft && now > new Date(formValues.end);

    return (
      <div>
        <AsyncSelect
          cacheOptions
          isMulti
          placeholder="Pesquise o usuário"
          noOptionsMessage={() => 'Não encontrado'}
          loadingMessage={() => 'Pesquisando...'}
          defaultOptions
          loadOptions={this.getSelectContacts}
          value={this.state.selectedValues}
          onChange={vals => {
            this.setState({
              selectedValues: vals,
              isAsyncInputDirty: true,
            });
            field.input.onChange(vals);
          }}
          isDisabled={disabled}
        />
        {field.meta.touched && field.meta.error ? (
          <FormHelperText style={{ color: '#FF5A52' }}>
            {field.meta.error}
          </FormHelperText>
        ) : (
          <FormHelperText>
            Você pode selecionar mais de uma opção
          </FormHelperText>
        )}
      </div>
    );
  };

  onSubmit = async values => {
    if (values.has_target && this.state.isAsyncInputDirty) {
      values.segment_users = values.segment_users.map(u => u.value);
    }

    const audienceTypes = buildAudienceTypes(this.props.auth, values);
    if (
      isStationGuestFeatureEnabled(this.props.auth) &&
      !hasAnyAudienceSelected(values)
    ) {
      this.props.requiredFieldError();
      return;
    }

    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      const stationImages = values.station_images || this.props.formValues?.station_images || {};

      // Preparar dados para publicação TanqueCheio
      const publishData = {
        ...(values.id ? { id: values.id } : {}),
        name: values.name,
        description: values.description,
        category_id: values.categories_field?.[0]?.id || values.category,
        categories: values.categories_field?.map(c => c.id) || [],
        stations: values.stations_field?.map(s => s.id) || values.stations || [],
        station_images: stationImages,
        start: values.start,
        end: values.end,
        participationStart: values.participationStart,
        participationEnd: values.participationEnd,
        points: values.points || 0,
        limit: values.total_vouchers_available || values.limit || 1000,
        // Segmentation fields
        has_target: values.has_target || false,
        ...(audienceTypes ? { audience_types: audienceTypes } : {}),
        segmentation_type: values.segmentation_type,
        from: values.from,
        to: values.to,
        states: values.states || [],
        associated: values.associated || 'all',
        internal: values.internal || 'all',
        segment_plans: values.segment_plans,
        entities: values.entities,
        segment_users: values.segment_users,
        click_me_label: values.click_me_label,
        featuredPrivate: values.featuredPrivate || false,
        featuredPublic: values.featuredPublic || false,
        comments_and_likes_enabled: values.comments_and_likes_enabled !== false,
        // TanqueCheio specific fields
        liters_per_voucher: values.liters_per_voucher,
        total_vouchers_available: values.total_vouchers_available,
        vouchers_per_client: values.vouchers_per_client,
        net_price_per_liter: values.net_price_per_liter,
        tipo_combustivel: values.tipo_combustivel,
        rede_id: values.rede_id,
        voucher_regulation: values.voucher_regulation,
        voucher_expiration: values.voucher_expiration,
        fuel_config: values.fuel_config || {},
        voucher_info: values.voucher_info || {},
        network_name: values.network_name || null,
        active: values.active !== false,
        sponsored: values.sponsored || false,
        image_id: values.image_id || null,
        trophy_image_id: values.trophy_image_id || null,
        featured_image_id: values.featured_image_id || null,
        image: values.image || null,
        is_tanque_cheio: 1
      };

      const response = await fetch(`${BASE_API}/tanque-cheio/publish`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        },
        body: JSON.stringify(publishData)
      });

      const result = await response.json();

      if (response.ok) {
        const isUpdate = !!values.id;
        toastr.success(
          'Sucesso',
          isUpdate ? 'Atividade atualizada com sucesso!' : 'Atividade publicada com sucesso!'
        );
        this.props.closeModal();
        window.location.href = '#/owner/tanque-cheio';
      } else {
        toastr.error('Erro', result.messages?.[0] || result.error || 'Erro ao publicar atividade');
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      toastr.error('Erro', 'Erro ao conectar com o servidor');
    }
  };

  render() {
    const {
      auth,
      activeActions,
      formValues,
      general,
      plans,
      prevClick,
      handleCancelClose,
      openConfirmation,
      buttonConfirmationLabel,
      closeModal,
    } = this.props;

    const now = new Date();
    const isDisabled = formValues.is_tanque_cheio ? false : (!formValues.is_draft && now > new Date(formValues.end));
    const ageError = "A idade 'De' está menor que 'Para'";

    const statesList = this.state.states.map(s => ({
      value: s.sigla,
      label: s.nome,
    }));
    const plansList = plans.list.content.map(p => ({
      value: p.id,
      label: p.name,
    }));

    return (
      <>
        <Form onSubmit={this.props.handleSubmit(this.onSubmit)} noValidate>
          <Box
            sx={{
              overflowY: 'auto',
              height: isMobile
                ? 'calc(100vh - 250px)'
                : 'calc(100vh - 355px)',
              overflowX: 'hidden',
              pr: isMobile ? 0 : 2,
            }}
          >
            {/** 1) Agendamento da publicação **/}
            <Typography
              variant="subtitle2"
              sx={{ fontSize: 16, fontWeight: 400, mt: 2 }}
            >
              Agendamento da publicação
            </Typography>
            <MaterialGrid container spacing={3}>
              <MaterialGrid item xs={12} md={6}>
                <Field
                  name="start"
                  component={({ input, meta }) => (
                    <TextField
                      label="Início"
                      type="datetime-local"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched ? meta.error : ''}
                      disabled={isDisabled}
                      {...input}
                    />
                  )}
                  validate={[FORM_RULES.required]}
                />
              </MaterialGrid>
              <MaterialGrid item xs={12} md={6}>
                <Field
                  name="end"
                  component={({ input, meta }) => (
                    <TextField
                      label="Fim"
                      type="datetime-local"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched ? meta.error : ''}
                      disabled={isDisabled}
                      {...input}
                    />
                  )}
                  validate={[FORM_RULES.required]}
                />
              </MaterialGrid>
            </MaterialGrid>

            {/** 2) Agendamento da participação **/}
            <Typography
              variant="subtitle2"
              sx={{ fontSize: 16, fontWeight: 400, mt: 2 }}
            >
              Agendamento da participação
            </Typography>
            <MaterialGrid container spacing={3}>
              <MaterialGrid item xs={12} md={6}>
                <Field
                  name="participationStart"
                  component={({ input, meta }) => (
                    <TextField
                      label="Início"
                      type="datetime-local"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched ? meta.error : ''}
                      disabled={isDisabled}
                      {...input}
                    />
                  )}
                  validate={[FORM_RULES.required]}
                />
              </MaterialGrid>
              <MaterialGrid item xs={12} md={6}>
                <Field
                  name="participationEnd"
                  component={({ input, meta }) => (
                    <TextField
                      label="Fim"
                      type="datetime-local"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched ? meta.error : ''}
                      disabled={isDisabled}
                      {...input}
                    />
                  )}
                  validate={[FORM_RULES.required]}
                />
              </MaterialGrid>
            </MaterialGrid>

            {formValues.is_event && (
              <MaterialGrid container spacing={3} sx={{ mt: 2 }}>
                <MaterialGrid item xs={12} md={6}>
                  <Field
                    name="event_start"
                    component={({ input, meta }) => (
                      <TextField
                        label="Data de início do evento"
                        type="datetime-local"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched ? meta.error : ''}
                        disabled={isDisabled}
                        {...input}
                      />
                    )}
                    validate={[FORM_RULES.required]}
                  />
                </MaterialGrid>
                <MaterialGrid item xs={12} md={6}>
                  <Field
                    name="event_end"
                    component={({ input, meta }) => (
                      <TextField
                        label="Data do fim do evento"
                        type="datetime-local"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched ? meta.error : ''}
                        disabled={isDisabled}
                        {...input}
                      />
                    )}
                    validate={[FORM_RULES.required]}
                  />
                </MaterialGrid>
              </MaterialGrid>
            )}

            <MaterialGrid item xs={12} sx={{ mt: 2 }}>
              <Field
                component={InputSwitchLarge}
                label="Ordem"
                name="hasPriority"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>
            {formValues.hasPriority && (
              <MaterialGrid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label="1-1000"
                  helperText="Determina a posição desta atividade na estação."
                  name="priority"
                  required
                  margin="normal"
                />
              </MaterialGrid>
            )}

            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label="Ordenar no carrossel"
                name="hasPriorityInCarousel"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>
            {formValues.hasPriorityInCarousel && (
              <MaterialGrid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label="1-1000"
                  helperText="Posição no carrossel em destaque."
                  name="priorityCarousel"
                  required
                  margin="normal"
                />
              </MaterialGrid>
            )}

            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label="Limitar atividade por público alvo"
                name="has_target"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>
            {formValues.has_target && (
              <>
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: 16, fontWeight: 400, mt: 2 }}
                >
                  Definir público alvo
                </Typography>
                <MaterialGrid container spacing={3}>
                  <MaterialGrid item xs={12} md={6}>
                    <Field
                      component={SelectLabel}
                      label="Tipo de segmentação"
                      name="segmentation_type"
                      options={[
                        { value: 'public', label: 'Por público' },
                        { value: 'users', label: 'Para usuários específicos' },
                      ]}
                      validate={[FORM_RULES.required]}
                      disabled={isDisabled}
                      margin="normal"
                    />
                  </MaterialGrid>
                </MaterialGrid>

                {formValues.segmentation_type === 'users' ? (
                  <MaterialGrid container spacing={3}>
                    <MaterialGrid item xs={12} md={6}>
                      <Field
                        name="segment_users"
                        component={this.lazySelect}
                        validate={[FORM_RULES.required]}
                        required
                        margin="normal"
                        disabled={isDisabled}
                      />
                    </MaterialGrid>
                  </MaterialGrid>
                ) : formValues.segmentation_type === 'public' ? (
                  <>
                    <MaterialGrid container spacing={3}>
                      <MaterialGrid item xs={12} md={6} lg={3}>
                        <Field
                          component={InputLabelOutlined}
                          label="De (anos)"
                          name="from"
                          type="number"
                          validate={[FORM_RULES.required]}
                          required
                          margin="normal"
                          helperText={
                            formValues.from > formValues.to ? ageError : null
                          }
                          disabled={isDisabled}
                        />
                      </MaterialGrid>
                      <MaterialGrid item xs={12} md={6} lg={3}>
                        <Field
                          component={InputLabelOutlined}
                          label="Até (anos)"
                          name="to"
                          type="number"
                          validate={[FORM_RULES.required]}
                          required
                          margin="normal"
                          helperText={
                            formValues.from > formValues.to ? ageError : null
                          }
                          disabled={isDisabled}
                        />
                      </MaterialGrid>
                    </MaterialGrid>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontSize: 16, fontWeight: 400, mt: 2 }}
                    >
                      Local de divulgação
                    </Typography>
                    <MaterialGrid container spacing={3}>
                      <MaterialGrid item xs={12} md={6}>
                        <Field
                          component={SelectMultiple}
                          label="Estados que poderão participar"
                          options={statesList}
                          name="states"
                          multiple
                          validate={[FORM_RULES.required]}
                          required
                          disabled={isDisabled}
                          margin="normal"
                        />
                      </MaterialGrid>
                    </MaterialGrid>
                    {plansList.length > 0 && (
                      <>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontSize: 16, fontWeight: 400, mt: 2 }}
                        >
                          Segmentar por Plano
                        </Typography>
                        <MaterialGrid container spacing={3}>
                          <MaterialGrid item xs={12} md={6}>
                            <Field
                              component={SelectMultiple}
                              label="Escolha o plano"
                              options={plansList}
                              multiple
                              disabled={isDisabled}
                              margin="normal"
                              name="segment_plans"
                            />
                          </MaterialGrid>
                        </MaterialGrid>
                      </>
                    )}
                  </>
                ) : null}
              </>
            )}

            <AudienceSection
              auth={this.props.auth}
              isDisabled={isDisabled}
              formValues={this.props.formValues}
              marginTop={16}
            />

            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label="Ocultar da área logada"
                name="only_public"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label="Destaque para participantes"
                name="featuredPrivate"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label="Destaque para visitantes"
                name="featuredPublic"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label="Comentários e curtidas habilitados"
                name="comments_and_likes_enabled"
                disabled={isDisabled}
                margin="normal"
              />
            </MaterialGrid>

            <GenericConfirmationCard
              open={openConfirmation}
              cancelClose={handleCancelClose}
              labelLeftButton="Continuar aqui"
              labelRightButton={this.props.buttonConfirmationLabel || "Sim, sair da edição"}
              title={this.props.confirmationTitle || "Deseja sair da edição?"}
              text={this.props.confirmationSubtitle || "Lembre-se, as informações que não foram salvas serão perdidas."}
              general={general}
              maxWidthFixed
              confirmButtonColor="primary"
              onClose={handleCancelClose}
              onClick={closeModal}
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={2}
            px={isMobile ? 2 : 0}
            pr={isMobile ? 0 : 2}
          >
            <SecondaryButton
              type="button"
              onClick={prevClick}
              style={{ width: '48%', textTransform: 'none' }}
            >
              Voltar
            </SecondaryButton>
            <PrimaryButton
              type="submit"
              color="primary"
              disabled={activeActions.buttonLoading || isDisabled}
              progress={parseInt(general.submitProgress)}
              onClick={() => this.setState({ submitted: true })}
              style={{ width: '48%', textTransform: 'none' }}
            >
              {activeActions.buttonLoading ? 'Publicando' : 'Publicar'}
            </PrimaryButton>
          </Box>
        </Form>
      </>
    );
  }
}

Publish.propTypes = {
  auth: PropTypes.object.isRequired,
  activeActions: PropTypes.shape({
    buttonLoading: PropTypes.bool,
  }).isRequired,
  formValues: PropTypes.object,
  general: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  plans: PropTypes.object.isRequired,
  submitErrors: PropTypes.object,
  openConfirmation: PropTypes.bool.isRequired,
  buttonConfirmationLabel: PropTypes.string,
  handleCancelClose: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  prevClick: PropTypes.func.isRequired,
  onClickProgress: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  activeActions: state.activeActions,
  formValues: getFormValues('tanqueCheioForm')(state) || {},
  general: state.general,
  contacts: state.contacts,
  submitErrors:
    getFormSyncErrors('tanqueCheioForm')(state) || {},
  plans: state.plans,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getContactsByStationIdLimited,
      getUsersByIds,
      requiredFieldError,
      getPlansList,
      changeField: change,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'tanqueCheioForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Publish)
);
